"use strict";

exports.__esModule = true;
exports.default = has;
var _setup = require("./_setup.js");
// Internal function to check whether `key` is an own property name of `obj`.
function has(obj, key) {
  return obj != null && _setup.hasOwnProperty.call(obj, key);
}